// Ads.jsx

import React, { useEffect, useState, useRef } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";
import { useLanguage } from "../../contexts/LanguageContext";
import "./Ads.css";

const Ads = () => {
  const [ads, setAds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const intervalRef = useRef(null);
    const { translations: t } = useLanguage();


  // fetch ads
  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, "app/home/ads"));
        setAds(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("Error fetching ads:", e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  // auto‐scroll
  useEffect(() => {
    if (ads.length > 1) startAutoScroll();
    return stopAutoScroll;
  }, [ads]);

  const startAutoScroll = () => {
    stopAutoScroll();
    intervalRef.current = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % ads.length);
    }, 4000);
  };
  const stopAutoScroll = () => clearInterval(intervalRef.current);

  // wrap index safely
  const idx = (i) => (i + ads.length) % ads.length;
  const farPrevIndex = idx(currentIndex - 2);
  const prevIndex    = idx(currentIndex - 1);
  const nextIndex    = idx(currentIndex + 1);
  const farNextIndex = idx(currentIndex + 2);

  return (    
    <section className="ads-section">
      <h2 className="ads-title">{t.ads?.header?.title || "Featured Spotlights"}</h2>
      <p className="ads-subtitle">
        {t.ads?.header?.subtitle || "Explore top hand-picked promotions and curated ads — discover today’s best deals, all in one place for a seamless, personalized experience."}
      </p>

      {isLoading ? (
        <div className="ads-container loading">
          <div className="ads-loader" />
        </div>
      ) : !ads.length ? (
        <div className="ads-container empty">
          <p>No ads available at the moment</p>
        </div>
      ) : (
        <div
          className="ads-container"
          onMouseEnter={stopAutoScroll}
          onMouseLeave={startAutoScroll}
        >
          <div className="ads-carousel">
            {[
              { pos: "far-prev", adIndex: farPrevIndex },
              { pos: "prev",     adIndex: prevIndex    },
              { pos: "center",   adIndex: currentIndex },
              { pos: "next",     adIndex: nextIndex    },
              { pos: "far-next", adIndex: farNextIndex },
            ].map(({ pos, adIndex }) => {
              const ad = ads[adIndex];
              return (
                <div
                  key={`${pos}-${ad.id}`}
                  className={`ad-card ${pos}`}
                  onClick={() => {
                    if (adIndex !== currentIndex) {
                      setCurrentIndex(adIndex);
                    } else if (ad.route) {
                      window.location.href = ad.route;
                    }
                  }}
                >
                  <img src={ad.imageUrl} alt={`Ad ${ad.id}`} />
                </div>
              );
            })}
          </div>

          <div className="ads-dots">
            {ads.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default Ads;
